export enum LocalizationConsts {
    Italian = 'it',
    English = 'en'
}
